import React, { useEffect, useState } from 'react';
import { IResponsiveStepComponent, IStepsType } from '../../../utils/interface';
import { STEPS_VIDEO_KYC_IN_COMPLETE, STEPS_VIDEO_KYC_COMPLETED } from '../../../utils/constants';
import {
  MainContainer,
  ScrollableContainer,
  ScrollableHeader,
  StepContainer,
  StepNumber,
  StepText,
  Heading,
  SubHeading,
  StepNumberWrapper
} from './style';

const ResponsiveStepComponent: React.FC<IResponsiveStepComponent> = (props) => {
  const { isVideoKycCompleted } = props;
  const [steps, setSteps] = useState<IStepsType[]>(STEPS_VIDEO_KYC_IN_COMPLETE);

  useEffect(() => {
    if (isVideoKycCompleted) {
      setSteps(STEPS_VIDEO_KYC_COMPLETED);
    } else {
      setSteps(STEPS_VIDEO_KYC_IN_COMPLETE);
    }
  }, [isVideoKycCompleted]);

  return (
    <MainContainer>
      <ScrollableContainer>
        <ScrollableHeader>
          {steps.map((step: IStepsType, index: number) => (
            <StepContainer key={index}>
              <StepNumberWrapper>
                <StepNumber>{index + 1}</StepNumber>
              </StepNumberWrapper>
              <StepText>
                <Heading>{step?.heading}</Heading>
                <SubHeading>{step?.subheading}</SubHeading>
              </StepText>
            </StepContainer>
          ))}
        </ScrollableHeader>
      </ScrollableContainer>
    </MainContainer>
  );
};

export default ResponsiveStepComponent;
